import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Task } from "../../../interfaces/task";

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  api: string = `${environment.api}/student/tasks`;

  constructor(private http: HttpClient) {
  }

  public index() {
    return this.http.get<Task[]>(this.api, { observe: "body" });
  }
}
